import { useEffect, useState } from 'react';
import { getDocumentExtentionsEffect } from '../common/CommonEffects';

const useDocsExtentions = (moduleId) => {
  const [extsList, setExtsList] = useState(null);

  useEffect(() => {
    if (moduleId) getExtsList();
  }, [moduleId]);

  const getExtsList = async () => {
    try {
      const { data } = await getDocumentExtentionsEffect({ moduleId });
      setExtsList(data[0].allowExtension.split(','));
    } catch {
      setExtsList(null);
    }
  };

  return extsList;
};

export default useDocsExtentions;
